import baseService from "./baseService";

export default class ExpenseService extends baseService {
  constructor() {
    super();
    this.schemaName = "api";
  }

  getExpenses(data) {
    return this.getObject(this.schemaName, "getExpenses", data);
  }

  createExpense(data) {
    return this.postObject(this.schemaName, "createExpense", data);
  }

  updateExpense(id, data) {
    return this.putObjectWithId(this.schemaName, "updateExpense", id, data);
  }

  deleteExpense(data) {
    return this.deleteObject(this.schemaName, "deleteExpense", data);
  }

  getExpenseCategories(data) {
    return this.getObject(this.schemaName, "getExpenseCategories", data);
  }

  createExpenseCategory(data) {
    return this.postObject(this.schemaName, "createExpenseCategory", data);
  }

  deleteExpenseCategory(data) {
    return this.deleteObject(this.schemaName, "deleteExpenseCategory", data);
  }
} 